export default "__VITE_ASSET__DtsBYsIg__"